import React, { useState, useEffect } from "react";
import { db, auth } from "../utils/firebase";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import {
  addDoc,
  collection,
  getDocs,
  query,
  serverTimestamp,
  where,
  onSnapshot,
  orderBy,
  doc,
  deleteDoc,
} from "firebase/firestore";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const GuestBook = () => {
  const [user, setUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");

  const handleGoogleAuth = async () => {
    const googleProvider = new GoogleAuthProvider();
    try {
      const res = await signInWithPopup(auth, googleProvider);
      const user = res.user;
      const q = query(collection(db, "users"), where("uid", "==", user.uid));
      const docs = await getDocs(q);
      if (docs.docs.length === 0) {
        await addDoc(collection(db, "users"), {
          uid: user.uid,
          name: user.displayName,
          authProvider: "google",
          email: user.email,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
        cookies.set("user", user, { path: "/" }); // Save user info in cookies
      } else {
        setUser(null);
        cookies.remove("user", { path: "/" }); // Remove user info from cookies
      }
    });

    const userFromCookie = cookies.get("user");
    if (userFromCookie) {
      setUser(userFromCookie);
    }

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const q = query(collection(db, "messages"), orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const messagesData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMessages(messagesData);
    });

    return () => unsubscribe();
  }, []);

  const signOut = () => {
    auth.signOut();
  };

  const handleSubmit = async () => {
    try {
      if (!user) {
        alert("You need to sign in to leave a message.");
        return;
      }
      if (newMessage == "") {
        alert("Enter a message to sign");
        return;
      }

      await addDoc(collection(db, "messages"), {
        text: newMessage,
        userId: user.uid,
        userName: user.displayName,
        createdAt: serverTimestamp(),
      });

      setNewMessage("");
    } catch (e) {
      console.log(e);
    }
  };

  const handleDelete = async (messageId) => {
    try {
      await deleteDoc(doc(db, "messages", messageId));
    } catch (error) {
      console.error("Error deleting message: ", error);
    }
  };

  return (
    <div className="mt-[65px] p-5 sm:p-10">
      <p className="text-2xl sm:text-3xl font-bold text-heading">
        Sign My Guestbook !!
      </p>
      <div className="my-10">
        {!user ? (
          <div className="">
            <button
              onClick={handleGoogleAuth}
              className="flex items-center gap-2 rounded-md shadow-md px-5 py-2"
            >
              <img
                className="h-6 w-6"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/1200px-Google_%22G%22_logo.svg.png"
                alt=""
              />
              <p className="text-lg text-content">Sign In With Google</p>
            </button>
          </div>
        ) : (
          <>
            <div className="">
              <span className="relative w-[95%] md:w-[500px] flex items-center gradient-bg py-2 rounded-md pr-12 pl-4 text-lg">
                <input
                  className="bg-transparent text-reverse w-full mr-10 outline-none"
                  type="text"
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  placeholder="Your message"
                />
                <button
                  onClick={handleSubmit}
                  className="absolute background text-lg rounded-md py-1 px-4 mx-1 ml-12 right-0"
                >
                  Sign
                </button>
              </span>
            </div>
            <p
              className="text-sm text-content mt-2 cursor-pointer"
              onClick={signOut}
            >
              Sign Out
            </p>
          </>
        )}
      </div>
      {messages.map((item) => (
        <div key={item.id} className="my-2">
          <p className="text-sm sm:text-base">
            <span className=" text-content">{item.userName}:</span>{" "}
            <span className="text-reverse">{item.text}</span>
          </p>
          {user && user.email == "rushigandhi14@gmail.com" && (
            <span
              onClick={() => handleDelete(item.id)}
              className="text-red-500 cursor-pointer"
            >
              Delete
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default GuestBook;
